import { StyleSheet, Text, View } from 'react-native'
import React from 'react'

// styles
import globalStyles from '../styles/global'

const PostCategoryFilterTitle = ({ term, filterBy, size, desc }) => {
  return (
    <View style={styles.titleContainer}>
      <Text
        style={[
          globalStyles.textBold,
          globalStyles.primaryColor,
          styles.titleText
        ]}
      >
        Posts related to
      </Text>
      <View style={[styles.titleTextWrap]}>
        <Text
          style={[
            globalStyles.textBold,
            globalStyles.primaryColor,
            styles.titleText,
            styles.titleHighlight
          ]}
        >
          {`${term}`}
        </Text>
      </View>
      <Text
        style={[
          globalStyles.textBold,
          globalStyles.primaryColor,
          styles.titleText
        ]}
      >
        {filterBy} ({size} {size === 1 ? 'post' : 'posts'}).
      </Text>

      <View style={styles.desc}>
        <Text style={[globalStyles.text, styles.descText]}>{desc}</Text>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: 16,
    marginBottom: 8
  },
  titleTextWrap: {
    borderRadius: 20,
    backgroundColor: 'rgba(88, 54, 204, .1)',
    marginHorizontal: 6,
    paddingHorizontal: 12,
    paddingBottom: 2
  },
  titleText: {
    fontSize: 18,
    lineHeight: 23,
    paddingTop: 0,
    paddingBottom: 1
  },
  titleHighlight: {
    flexDirection: 'column',
    color: 'rgba(88, 54, 204, 1)',
    textTransform: 'lowercase'
  },
  desc: {
    marginTop: 30,
    marginBottom: 0,
    borderBottomWidth: 1,
    borderColor: '#E9ECEF',
    paddingBottom: 20,
    width: '100%'
  },
  descText: {
    fontSize: 16,
    color: 'rgba(15, 23, 42, .7)'
  }
})

export default PostCategoryFilterTitle
